import React from "react";
import { useTable, useSortBy } from "react-table";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Button } from "react-bootstrap";
import useFetch from "../../../fetch";
import { UpArrow, DownArrow, DefaultArrow } from "../../../sortArrows";


export default function MedicationsTable(props) {
  const { medications, resident, ui, organization } = useSelector(state=>state)
  const { action } = ui
  const organizationName = organization.name
  const dispatch = useDispatch()
  const fetch = useFetch()

  const columns = React.useMemo(()=>[
    medicationStartedOn,
    medicationStatus,
    medicationName,
    medicationDosage,
    medicationQuantity,
    medicationRemaining,
    medicationCategory,
    medicationFrequency,
    medicationMd,
    medicationNotes,
    medicationSignature,
  ],[medications])
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: medications
  }, useSortBy)
  

  return (
    <table {...getTableProps()} className="table table-responsive">
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                <div style={ !column.disableSorting ? { position: 'relative', top: '4px' } : {}}>
                  {column.render('Header')}
                  <span>
                    {
                      !column.disableSorting ?
                      column.isSorted ? (column.isSortedDesc ? <DownArrow /> : <UpArrow />) : <DefaultArrow /> : null
                    }
                  </span>
                </div>
              </th>
            ))}
            <th />
          </tr>
        ))}
      </thead>
      <tbody>
        {rows.map(
          (row, i) =>
            prepareRow(row) || (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
                <td>
                  {
                    action === "edit" &&
                    <span>
                      <a
                        href="#"
                        className="m-1"
                        onClick={(e) => {
                          e.preventDefault();
                          props.editMedication(row.original);
                        }}>
                        Edit
                      </a>
                      {
                        organization.medlogs &&
                        moment(row.original.created_at).isAfter("2019-06-18") &&
                        <a
                          href="#"
                          className="m-1"
                          onClick={(e) => {
                            e.preventDefault()
                            props.refillMedication(row.original);
                          }}>
                          Refill
                        </a>
                      }
                    </span>
                  }
                </td>
              </tr>
            )
        )}
      </tbody>
    </table>
  )
}

function renderRemaining(remaining_quantity) {
  if (remaining_quantity) {
    const quantity = parseFloat(remaining_quantity);

    if(quantity > 10) {
      return (
        <span className="text-success">{remaining_quantity}</span>
      )
    } else if (quantity > 5) {
      return (
        <span className="text-warning">{remaining_quantity}</span>
      );
    } else {
      return (
        <span className="text-danger">{remaining_quantity}</span>
      )
    }
  }
}

const medicationName = {
  Header: 'Medication',
  id: 'name',
  accessor: row => !!row.name && row.name.toLowerCase(),
  disableSorting: false,
  Cell: ({cell:{row:{original}}}) => <span>{original.name}</span>
}

const medicationStartedOn = {
  Header: 'Started On',
  id: 'started_at',
  accessor: row => row.started_at,
  disableSorting: true,
  Cell: ({cell:{row:{original}}}) => <span>{original.started_at ? moment(original.started_at).format("ll") : 'No Started On Date'}</span>
}

const medicationStatus = {
  Header: 'Status',
  id: 'status',
  accessor: row => row.status,
  disableSorting: true,
  Cell: ({ cell: { row: { original } } }) => {
    const getStatus = () => {
      if (original.discontinued_at && moment(original.discontinued_at).isBefore(moment())) {
        return `Discontinued - ${moment(original.discontinued_at).format("MM/DD/YYYY")}`;
      } else if (moment(original.started_at).isAfter(moment())) {
        return 'Inactive';
      } else {
        return 'Active';
      }
    };

    return <span>{getStatus()}</span>;
  }
};

const medicationDosage = {
  Header: 'Dosage',
  id: 'dosage',
  accessor: row => row.dosage,
  disableSorting: true,
  Cell: ({cell:{row:{original}}}) => <span>{original.dosage}</span>
}

const medicationQuantity = {
  Header: 'Qty',
  id: 'quantity',
  accessor: row => row.quantity,
  disableSorting: true,
  Cell: ({cell:{row:{original}}}) => <span>{original.quantity}</span>
}

const medicationRemaining = {
  Header: 'Remaining',
  id: 'remaining',
  accessor: row => row.remaining_quantity,
  disableSorting: true,
  Cell: ({cell:{row:{original}}}) => <span>{renderRemaining(original.remaining_quantity)}</span>
}

const medicationCategory = {
  Header: 'Category',
  id: 'category',
  accessor: row => row.category,
  disableSorting: false,
  Cell: ({cell:{row:{original}}}) => <span>{original.category}</span>
}

const medicationFrequency = {
  Header: 'Frequency',
  id: 'frequency',
  accessor: row => row.name,
  disableSorting: true,
  Cell: ({cell:{row:{original}}}) => <span>{original.frequency}</span>
}

const medicationMd = {
  Header: 'Md',
  id: 'md',
  accessor: row => row.md,
  disableSorting: true,
  Cell: ({cell:{row:{original}}}) => <span>{original.md}</span>
}

const medicationNotes = {
  Header: 'Notes',
  id: 'notes',
  accessor: row => row.notes,
  disableSorting: true,
  Cell: ({cell:{row:{original}}}) => <span>{original.notes}</span>
}

const medicationSignature = {
  Header: 'Signature',
  id: 'signature',
  accessor: row => row.name,
  disableSorting: true,
  Cell: ({cell:{row:{original}}}) => <span>{ original.signature_url !== "/signatures/original/missing.png" && <img src={original.signature_url} style={{ height: 50 }} /> }</span>
}
